import React, { useState } from 'react';
import Header   from './components/Header';
import HoursForm from './components/HoursForm';
import Tracker  from './components/Tracker';
import Toast    from './components/Toast';
import { useHoursForm } from './hooks/useHoursForm';
import './App.css';

export default function App() {
  const [activeTab, setActiveTab] = useState('form');

  const {
    rows, progress, allDone, submitted, toast,
    log, meta,
    setHours, setDate, toggleNA,
    savePartial, submit,
    resetTracker, clearLog,
  } = useHoursForm();

  return (
    <>
      <Header activeTab={activeTab} onTabChange={setActiveTab} />

      <Toast toast={toast} />

      {activeTab === 'form' && (
        <HoursForm
          rows={rows}
          progress={progress}
          allDone={allDone}
          submitted={submitted}
          setHours={setHours}
          setDate={setDate}
          toggleNA={toggleNA}
          savePartial={savePartial}
          submit={submit}
        />
      )}

      {activeTab === 'tracker' && (
        <Tracker
          rows={rows}
          log={log}
          meta={meta}
          resetTracker={resetTracker}
          clearLog={clearLog}
        />
      )}
    </>
  );
}
